module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_7016.5c1bc83f.png";